import React from 'react';
import { useTranslation } from 'react-i18next';
import { SymbolDetailLabeledValue } from '../../../../symbol-detail/labeled-value/symbol-detail-labeled-value';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { formatBigNumber } from '../../../../value/utils/format-big-number';

interface FairPriceTabDcfStatsProps {
    currency: string;
    totalFcf: number | null;
    cash: number | null;
    debt: number | null;
    sharesOutstanding: number | null;
}

const renderMoneyValue = (amount: number | null, currency: string) =>
    amount != null ? <ValueAmount mode="pure" amount={amount} currency={currency} fractionDigits={0} bigNumber /> : '—';

const renderNumberValue = (amount: number | null, currency: string) =>
    amount != null ? `${formatBigNumber(amount, 0, '')} ${currency}` : '—';

export const FairPriceTabDcfStats: React.FC<FairPriceTabDcfStatsProps> = ({
    currency,
    totalFcf,
    cash,
    debt,
    sharesOutstanding,
}) => {
    const { t } = useTranslation();

    return (
        <div className="mb-medium rounded-medium border border-border px-small pb-small pt-medium">
            <div className="mb-medium flex items-center justify-between gap-small sm:max:flex-col sm:max:items-start">
                <div className="text-[2.4rem] font-bold leading-[3.2rem] text-brand-secondary">
                    {t('layout.dialogs.fairPrice.dcf.defaultValues')}
                </div>
            </div>
            <div className="grid gap-y-small gap-x-vlarge sm:grid-cols-2">
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.dcf.totalFcfTTM')}
                    value={renderMoneyValue(totalFcf, currency)}
                />
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.dcf.cash')}
                    value={renderMoneyValue(cash, currency)}
                />
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.dcf.debt')}
                    value={renderMoneyValue(debt, currency)}
                />
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.dcf.sharesOutstanding')}
                    value={renderNumberValue(sharesOutstanding, currency)}
                />
            </div>
        </div>
    );
};
